// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --vae-font-size-scale: 1;
  --vae-line-height: 1.5;
  --vae-letter-spacing: 0px;
  --vae-word-spacing: 0px;
  --vae-background-color: #ffffff;
  --vae-text-color: #000000;
  --vae-contrast-factor: 1;
  --vae-text-contrast: 1;
  --vae-animation-speed: 1;
  --vae-interactive-highlight-color: #2563eb;
  --vae-interactive-highlight-outline: 2px;
  --vae-cursor-size: 24px;
  --vae-cursor-color: #2563eb;
  
  /* Layout variables */
  --vae-container-padding: 1rem;
  --vae-content-padding: 1rem;
  --vae-header-height: 72px;
  
  /* Icon sizing variables */
  --vae-section-icon-size: 2.625rem;
  --vae-section-icon-inner-size: 1.5rem;
  --vae-section-icon-border-radius: 0.5rem;
  
  /* Header variables */
  --vae-border-color: #E5E7EB;
  --vae-header-icon-bg: #2563eb;
  --vae-header-icon-color: #ffffff;
  
  /* Profile card variables */
  --vae-modal-bg: #ffffff;
  --vae-modal-text: #111827;
  --vae-subtle-bg: #f9fafb;
  --vae-footer-text: #6b7280;
  --vae-profile-icon-size: 1.5rem;
  --vae-profile-icon-container-padding: 0.25rem;

  --vae-primary-color: #2563eb;
  --vae-primary-rgb: 37, 99, 235;
  --vae-bg-light: #ffffff;
  --vae-bg-dark: #171717;
  --vae-text-light: #171717;
  --vae-text-dark: #f5f5f5;
  --vae-subtle-bg: #f9f9f9;
  --vae-subtle-bg-dark: #262626;
  --vae-modal-bg: #ffffff;
  --vae-modal-bg-dark: #262626;
  --vae-border-light: #e5e5e5;
  --vae-border-dark: #404040;
  --vae-hover-light: #f5f5f5;
  --vae-hover-dark: #333333;
  --vae-shadow-color: rgba(0, 0, 0, 0.1);
  --vae-shadow-color-dark: rgba(0, 0, 0, 0.3);
  --vae-modal-text: #262626;
  --vae-modal-text-dark: #e5e5e5;
}

.vae-severity-critical {
  background-color: #dc2626 !important;
  color: white !important;
}

.vae-severity-high {
  background-color: #ea580c !important;
  color: white !important;
}

.vae-severity-medium {
  background-color: #eab308 !important;
  color: black !important;
}

.vae-severity-low {
  background-color: #22c55e !important;
  color: white !important;
}

.vae-severity-unknown {
  background-color: #6b7280 !important;
  color: white !important;
}

.vae-severity-section.vae-severity-critical .vae-collapsable-header {
  border-left: 4px solid #ef4444;
}

.vae-severity-section.vae-severity-high .vae-collapsable-header {
  border-left: 4px solid #f97316;
}

.vae-severity-section.vae-severity-medium .vae-collapsable-header {
  border-left: 4px solid #f59e0b;
}

.vae-severity-section.vae-severity-low .vae-collapsable-header {
  border-left: 4px solid #10b981;
}

.vae-fix-detail-item .vae-detail-severity {
  display: inline-block;
  padding: 0.2rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 0.25rem;
  margin-right: 0.5rem;
}

.vae-detail-severity.vae-severity-critical {
  background-color: #fee2e2;
  color: #b91c1c;
}

.vae-detail-severity.vae-severity-high {
  background-color: #ffedd5;
  color: #c2410c;
}

.vae-detail-severity.vae-severity-medium {
  background-color: #fef3c7;
  color: #b45309;
}

.vae-detail-severity.vae-severity-low {
  background-color: #d1fae5;
  color: #047857;
}

.vae-detail-severity {
  text-transform: capitalize;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 12px;
  color: white;
}

#vae-widget-container {
  font-size: 16px !important;
  line-height: 1.5 !important;
  letter-spacing: normal !important;
  word-spacing: normal !important;
  position: fixed;
  bottom: 2rem;
  right: 4rem;
  z-index: 2147483647;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
}

#vae-button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to right, #2563eb, #7c3aed);
  border: none;
  border-radius: 0.5rem;
  padding: 0.75rem;
  cursor: pointer;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  color: white;
  width: 3.5rem;
  height: 3.5rem;
}

#vae-button:hover {
  background: linear-gradient(to right, #1d4ed8, #6d28d9);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

#vae-button:focus {
  outline: none;
  ring: 2px;
  ring-offset: 2px;
  ring-color: #2563eb;
}

.vae-button-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.vae-logo-container {
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.vae-logo {
  width: 2rem;
  height: 2rem;
  stroke: #3B82F6; /* Blue stroke - restored */
}

#vae-button .vae-logo {
  stroke: white; /* White stroke only for the button logo */
}

.vae-button-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.vae-button-title {
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1;
  display: flex;
  align-items: center;
  white-space: nowrap;
  color: white;
}

.vae-button-title a {
  color: white;
  text-decoration: none;
}

.vae-status-led {
  position: absolute;
  top: -0.25rem;
  right: -0.25rem;
  width: 0.5rem;
  height: 0.5rem;
  background: #ef4444;
  border-radius: 9999px;
  box-shadow: 0 0 6px rgba(239, 68, 68, 0.8);
  transition: all 0.3s ease;
}

.vae-status-led.active {
  background: #34d399;
  box-shadow: 0 0 6px rgba(52, 211, 153, 0.8);
}

/* Header Status LED */
.vae-header-status-led {
  position: absolute;
  top: -0.375rem;
  right: -0.375rem;
  width: 0.75rem;
  height: 0.75rem;
  background: #6b7280;
  border-radius: 9999px;
  box-shadow: 0 0 6px rgba(107, 114, 128, 0.5);
  transition: all 0.3s ease;
  z-index: 10;
}

/* Analysis Status Colors - with higher priority */
.vae-status-led.analysis-completed,
.vae-header-status-led.analysis-completed {
  background: #10b981 !important;
  box-shadow: 0 0 8px rgba(16, 185, 129, 0.8) !important;
  animation: vae-led-glow 2s ease-in-out infinite;
}

.vae-status-led.analysis-in-progress,
.vae-header-status-led.analysis-in-progress {
  background: #f97316 !important;
  box-shadow: 0 0 6px rgba(249, 115, 22, 0.8) !important;
  animation: vae-led-pulse 1.5s ease-in-out infinite;
}

/* Profile and Settings Status */
.vae-status-led.active-profile,
.vae-header-status-led.active-profile {
  background: #8b5cf6;
  box-shadow: 0 0 6px rgba(139, 92, 246, 0.8);
}

.vae-status-led.active-settings,
.vae-header-status-led.active-settings {
  background: #f59e0b;
  box-shadow: 0 0 6px rgba(245, 158, 11, 0.8);
}

/* LED Animations */
@keyframes vae-led-glow {
  0%, 100% {
    box-shadow: 0 0 8px rgba(16, 185, 129, 0.8);
  }
  50% {
    box-shadow: 0 0 16px rgba(16, 185, 129, 1);
  }
}

@keyframes vae-led-pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(0.95);
  }
}

/* Version Display */
.vae-version-number {
  position: absolute;
  bottom: 0.25rem;
  right: 0.5rem;
  font-size: 0.65rem;
  color: #9ca3af;
  font-family: 'Courier New', Courier, monospace;
  opacity: 0.7;
  z-index: 5;
  user-select: none;
  pointer-events: none;
}

.vae-footer .vae-version-number {
  position: absolute;
  bottom: 0.25rem;
  right: 0.5rem;
}

.vae-status-dot {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 9999px;
  background-color: #EF4444; /* Red */
  margin-left: 0.5rem;
  display: inline-block;
}

.vae-status-dot.active {
  background-color: #34D399; /* Green */
}

.vae-button-subtitle {
  font-size: 0.625rem;
  opacity: 0.9;
  line-height: 1;
  white-space: nowrap;
  margin-top: 0.25rem;
}

.vae-mobile-tooltip {
  position: absolute;
  right: 0;
  bottom: 100%;
  margin-bottom: 0.5rem;
  display: none;
}

.vae-mobile-tooltip-content {
  background: #111827;
  color: white;
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.2s ease;
}

#vae-button:hover .vae-mobile-tooltip-content {
  opacity: 1;
}

#vae-menu {
  position: absolute;
  bottom: 4rem;
  right: 0;
  width: 28rem;
  height: 80vh;
  max-height: 80vh;
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.15),
    0 10px 10px -5px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(0, 0, 0, 0.05),
    0 0 20px rgba(0, 0, 0, 0.1);
  padding: 0;
  display: none;
  opacity: 0;
  transform: translateY(1rem);
  transition: opacity 0.3s ease, transform 0.3s ease;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

#vae-menu.open {
  display: flex;
  opacity: 1;
  transform: translateY(0);
}

.vae-content {
  flex: 1;
  overflow-y: auto;
  margin-top: 0;
}

/* Make sure the content takes up all available space when displayed */
.vae-content:only-child {
  display: block;
}

.vae-content::-webkit-scrollbar {
  width: 0.375rem;
}

.vae-content::-webkit-scrollbar-track {
  background: #f3f4f6;
  border-radius: 0.25rem;
}

.vae-content::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 0.25rem;
}

.vae-content::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

.vae-section-divider {
  margin: 1.5rem 0 0.75rem 0;
  padding-top: 1rem;
}

.vae-content .vae-section-divider:first-child {
  margin-top: 0;
}

.vae-section-divider h3 {
  font-size: 1rem;
  font-weight: 600;
  color: #4b5563;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.vae-section-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--vae-section-icon-size);
  height: var(--vae-section-icon-size);
  border-radius: var(--vae-section-icon-border-radius);
  color: white;
}

.vae-section-icon svg {
  width: var(--vae-section-icon-inner-size);
  height: var(--vae-section-icon-inner-size);
}

/* Colored backgrounds for section icons */
.vae-text-icon {
  background-color: #f3e8ff; /* Light purple - matches Kognitive Hilfe */
  color: #a855f7; /* Purple stroke - matches Kognitive Hilfe */
}

.vae-colors-icon {
  background-color: #dcfce7; /* Light green - matches Sehbehinderung */
  color: #22c55e; /* Green - matches Sehbehinderung */
}

.vae-motion-icon {
  background-color: #fff7ed; /* Light orange - matches Motorische Hilfe */
  color: #f97316; /* Orange - matches Motorische Hilfe */
}

.vae-language-icon {
  background-color: #e5e0ff; /* Light purplish-blue */
  color: #6366f1; /* Indigo/purple - matches Indigo-600 */
}

.vae-config-icon {
  background-color: #10B981; /* green */
}

.vae-profile-icon {
  background-color: #e0f2fe; /* Light neutral blue */
  color: #000000; /* Black */
}

.vae-reader-icon {
  background-color: #3B82F6; /* blue */
}

.vae-menu-header {
  display: flex;
  flex-direction: column;
  padding: var(--vae-container-padding);
  border-bottom: 1px solid var(--vae-border-color);
  background-color: white;
  box-sizing: border-box;
  position: relative;
  z-index: 11;
}

.vae-header {
  flex-shrink: 0;
  border-bottom: 1px solid var(--vae-border-color);
}

.vae-header-content {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.vae-text-icon-wrapper {
  background-color: #EBF5FF;
  border-radius: 0.5rem;
  padding: 0.75rem;
  width: 2.5rem;
  height: 2.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.vae-text-icon-wrapper .vae-text-icon-letter {
  font-size: 1.5rem;
  font-weight: 500;
  color: #4F46E5;
}

.vae-menu-title-section {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.vae-menu-subtitle {
  font-size: 0.85rem;
  color: #6B7280;
  margin-bottom: 0.25rem;
}

.vae-menu-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
  margin: 0 0 0.25rem 0;
  line-height: 1.2;
}

.vae-menu-attribution {
  font-size: 0.85rem;
  color: #6B7280;
}

.vae-menu-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  margin-left: auto;
}

.vae-icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  color: #6b7280;
  border: none;
  background: none;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: all 0.2s ease;
  gap: 0.25rem;
}

.vae-icon-button .vae-button-text {
  font-size: 0.85rem;
  font-weight: 500;
}

.vae-icon-button svg {
  width: 1.25rem;
  height: 1.25rem;
}

.vae-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 200ms;
}

.vae-button:hover {
  background: #1d4ed8;
}

.vae-section-title {
  font-size: 1.3rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #1f2937;
  width: 100%;
}

.vae-fixed-list,
.vae-issues-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.vae-fixed-item {
  border-left: 3px solid #34d399;
}

.vae-issue-item {
  border-left: 3px solid #fbbf24;
}

.vae-fixed-label {
  display: inline-block;
  margin-left: 0.5rem;
  font-weight: 500;
  color: #059669;
}

.vae-all-fixed-message {
  background-color: #d1fae5;
  border-radius: 0.375rem;
  padding: 1rem;
  text-align: center;
  margin-top: 1rem;
}

.vae-all-fixed-message p {
  margin: 0;
  color: #065f46;
  font-weight: 500;
}

.vae-analysis-progress {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 0;
}

.vae-loading-spinner {
  width: 2rem;
  height: 2rem;
  border: 3px solid #e5e7eb;
  border-top-color: #2563eb;
  border-radius: 50%;
  margin-bottom: 1rem;
  animation: vae-spin 1s linear infinite;
}

@keyframes vae-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.vae-issue-description {
  font-size: 0.85rem;
  color: #4b5563;
  margin-bottom: 0.25rem;
  margin-top: 5px;
  line-height: 1.5;
}

.vae-fix-summary-container {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #333;
  background: white;
  border-radius: 0.75rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  width: 100%;
}

.vae-fix-summary-container h4 {
  margin: 0 0 10px 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.vae-fix-summary-container h5 {
  margin: 15px 0 8px 0;
  font-size: 16px;
  font-weight: 500;
  color: #555;
}

.vae-fix-summary-header h4 {
  margin: 0 0 0.5rem 0;
  font-size: 1.125rem;
  color: #111827;
}

.vae-fix-overview {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
  margin: 10px 0;
}
.vae-fix-button {
  width: 100%;
  display: block;
  margin: 0 auto;
  background: linear-gradient(90deg, #2563eb, #4f46e5);
  color: white;
  border: none;
  border-radius: 0.5rem;
  padding: 0.875rem 1.5rem;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  box-shadow: 0 4px 6px -1px rgba(79, 70, 229, 0.2),
    0 2px 4px -1px rgba(79, 70, 229, 0.1);
  transition: all 0.2s ease;
}

.vae-fix-button:hover {
  background: linear-gradient(90deg, #1d4ed8, #4338ca);
  box-shadow: 0 6px 10px -1px rgba(79, 70, 229, 0.25),
    0 4px 6px -1px rgba(79, 70, 229, 0.15);
  transform: translateY(-1px);
}

.vae-fix-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.4);
}

.vae-fix-button:disabled {
  background: linear-gradient(90deg, #93c5fd, #a5b4fc);
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}
.vae-fix-count {
  font-size: 0.9rem;
  font-weight: 500;
  padding: 3px 8px;
  border-radius: 4px;
  background: #f5f5f5;
}
.vae-fix-total-count {
  background: #e9e9e9;
}
.vae-fix-success-count {
  color: #28a745;
  background: rgba(40, 167, 69, 0.1);
}
.vae-fix-failure-count {
  color: #dc3545;
  background: rgba(220, 53, 69, 0.1);
}

.vae-fix-details-list {
  list-style: none;
  padding: 0.75rem;
  margin: 0;
  max-height: 300px;
  overflow-y: auto;
  font-size: 14px;
}

.vae-fix-detail-item {
  padding: 0.75rem;
  margin-bottom: 0.5rem;
  background-color: white;
  border-radius: 0.375rem;
  border-left: 3px solid #e5e7eb;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.vae-fix-detail-item:last-child {
  border-bottom: none;
}

.vae-fix-detail-item.vae-failure {
  background-color: rgba(220, 53, 69, 0.05);
}

.vae-fix-detail-item.vae-success {
  background-color: rgba(40, 167, 69, 0.05);
}

.vae-collapsable-header {
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background-color 0.2s;
  padding: 0.75rem 1rem;
  position: relative;
  transition: all 0.2s ease;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.vae-collapsable-header:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.vae-collapsable-section {
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease;
}

.vae-collapsable-section:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.vae-section-count {
  font-weight: normal;
  color: #eee;
  margin-left: 6px;
}

.vae-collapsable-content {
  background-color: #f9fafb;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.vae-detail-action {
  display: inline-block;
  font-weight: 600;
  font-size: 0.85rem;
  color: #4b5563;
  margin-right: 0.5rem;
  max-width: 80%;
}

.vae-detail-wcag {
  display: inline-block;
  font-size: 0.75rem;
  background-color: #e0f2fe;
  color: #0c4a6e;
  padding: 0.2rem 0.5rem;
  border-radius: 0.25rem;
  font-weight: 500;
}

.vae-detail-target {
  font-family: monospace;
  font-size: 0.85rem;
  background-color: #f8fafc;
  padding: 0.5rem;
  border-radius: 0.25rem;
  overflow-x: auto;
  white-space: nowrap;
  color: #334155;
  border: 1px solid #e2e8f0;
}

.vae-detail-header {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  margin-bottom: 0.5rem;
}
.vae-detail-status {
  font-weight: bold;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  margin-right: 0.5rem;
}

.vae-detail-status:first-child {
  background-color: #d1fae5;
  color: #047857;
}

.vae-detail-status:first-child:not(:only-child) {
  background-color: #fee2e2;
  color: #b91c1c;
}

.vae-detail-duration {
  font-family: monospace;
  font-size: 0.75rem;
  background-color: #f3f4f6;
  padding: 0.2rem 0.4rem;
  border-radius: 0.25rem;
  color: #6b7280;
  margin-left: auto;
}

.vae-detail-error {
  margin-top: 0.5rem;
  padding: 0.5rem;
  background-color: #fee2e2;
  border-left: 3px solid #b91c1c;
  color: #b91c1c;
  border-radius: 0.25rem;
  font-size: 0.875rem;
}
.vae-results-panel {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 320px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 15px;
  z-index: 9999;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.vae-results-panel h3 {
  margin: 0 0 10px;
  font-size: 16px;
  font-weight: 600;
}

.vae-stats {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.vae-stat {
  text-align: center;
  flex: 1;
  padding: 8px;
  border-radius: 4px;
}

.vae-stat-success {
  background-color: rgba(76, 175, 80, 0.1);
}

.vae-stat-failed {
  background-color: rgba(244, 67, 54, 0.1);
}

.vae-stat-skipped {
  background-color: rgba(255, 152, 0, 0.1);
}

.vae-stat-value {
  display: block;
  font-size: 24px;
  font-weight: bold;
}

.vae-stat-label {
  font-size: 12px;
  color: #666;
}

.vae-fix-details {
  margin-top: 10px;
}

.vae-fix-details summary {
  cursor: pointer;
  padding: 8px 0;
  user-select: none;
}

.vae-fix-list {
  max-height: 200px;
  overflow-y: auto;
  margin-top: 8px;
}

.vae-fix-item {
  padding: 8px;
  margin-bottom: 4px;
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.vae-fix-type {
  flex: 1;
  font-size: 12px;
  font-weight: 500;
}

.vae-fix-status {
  width: 20px;
  text-align: center;
  font-weight: bold;
}

.vae-fix-time {
  font-size: 11px;
  color: #666;
  margin-left: 8px;
}

/* Maximize accessibility button */
.vae-maximize-button {
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 0.9375rem;
  font-weight: 500;
  border-radius: 0.5rem;
  background-color: #2563eb;
  color: white;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.vae-maximize-button:hover {
  background-color: #1d4ed8;
}

.vae-reading-mode-toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.875rem 0;
  border-bottom: 1px solid #E5E7EB;
  margin-bottom: 0.75rem;
}

.vae-toggle-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  font-size: 0.9rem;
  color: #111827;
}

.vae-toggle-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #6B7280;
}

.vae-toggle-icon svg {
  width: 1rem;
  height: 1rem;
}

.vae-toggle-switch {
  position: relative;
  display: inline-block;
  width: 2.5rem;
  height: 1.5rem;
}

.vae-toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.vae-toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #E5E7EB;
  transition: .3s;
  border-radius: 1rem;
}

.vae-toggle-slider:before {
  position: absolute;
  content: "";
  height: 1.25rem;
  width: 1.25rem;
  left: 0.125rem;
  bottom: 0.125rem;
  background-color: white;
  transition: .3s;
  border-radius: 50%;
}

input:checked + .vae-toggle-slider {
  background-color: #2563EB;
}

input:checked + .vae-toggle-slider:before {
  transform: translateX(1rem);
}

.vae-footer {
  display: flex;
  flex-direction: column;
  padding: var(--vae-container-padding);
  border-top: 1px solid var(--vae-border-color);
  background-color: white;
  font-size: 0.75rem;
  gap: 16px;
  position: relative;
}

.vae-footer-columns-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.vae-footer-links-column {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.vae-footer-privacy-row {
  width: 100%;
  text-align: center;
  padding-top: 8px;
  border-top: 1px solid var(--vae-border-color-light, #e5e7eb);
}

.vae-footer a {
  color: #6b7280;
  text-decoration: none;
  transition: color 0.2s ease;
}

.vae-footer a:hover {
  text-decoration: underline;
}

.vae-footer-link {
  cursor: pointer;
}

/* Dark mode adjustments */
.vae-high-contrast .vae-profile-card.active {
  border-color: #fff;
  background-color: rgba(255, 255, 255, 0.2);
}

.vae-high-contrast-light .vae-profile-card.active {
  border-color: #000;
  background-color: rgba(0, 0, 0, 0.1);
}

@media (prefers-reduced-motion: reduce) {
  .vae-profile-card {
    transition: none;
  }
}

#vae-optimization-summary-content {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 10rem;
}

.vae-issue-description {
  font-size: 0.85rem;
  color: #4b5563;
  margin-bottom: 0.25rem;
  margin-top: 5px;
  line-height: 1.5;
}

#vae-settings-view {
  padding: var(--vae-content-padding);
}

/* Developer Tools Section */
.vae-developer-tools {
  padding: 1rem 0;
}

.vae-developer-tools .vae-button {
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 0.5rem;
  background-color: #6b7280;
  color: white;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin-bottom: 0.5rem;
}

.vae-developer-tools .vae-button:hover:not(:disabled) {
  background-color: #4b5563;
}

.vae-developer-tools .vae-button:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.7;
}

.vae-developer-tools .vae-help-text {
  font-size: 0.75rem;
  color: #6b7280;
  margin: 0;
  line-height: 1.4;
}

/* High contrast adjustments for developer tools */
.vae-high-contrast .vae-developer-tools .vae-button {
  background-color: #000000;
  color: #ffffff;
  border: 2px solid #ffffff;
}

.vae-high-contrast .vae-developer-tools .vae-button:hover:not(:disabled) {
  background-color: #333333;
}

.vae-high-contrast-light .vae-developer-tools .vae-button {
  background-color: #ffffff;
  color: #000000;
  border: 2px solid #000000;
}

.vae-high-contrast-light .vae-developer-tools .vae-button:hover:not(:disabled) {
  background-color: #f3f4f6;
}

/* Hide language features */
.vae-section-divider h3:has(.vae-language-icon),
.vae-section-divider:has(.vae-language-icon),
.vae-language-profiles {
  display: none;
}

.vae-title-dropdown-wrapper,
.vae-section-title-with-dropdown .vae-select-wrapper {
  display: none;
}

/* Hide analysis start button */
#vae-analysis-button-container {
  display: none;
}

/* Hide footer elements */
#vae-problem-report-link,
#vae-optimization-report-link {
  display: none;
}

.vae-footer-privacy-row {
  display: none;
}

/* Footer single row layout */
.vae-footer .vae-footer-single-row {
  display: flex !important;
  flex-direction: row !important;
  gap: 1rem !important;
  justify-content: flex-start !important;
}

.vae-footer .vae-footer-single-row a:last-child {
  margin-left: auto !important;
}

/* Hide privacy consent overlay completely */
#vae-privacy-consent-overlay {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./widget/assets/css/ui.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,0CAA0C;EAC1C,wCAAwC;EACxC,uBAAuB;EACvB,2BAA2B;;EAE3B,qBAAqB;EACrB,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;;EAEzB,0BAA0B;EAC1B,iCAAiC;EACjC,qCAAqC;EACrC,wCAAwC;;EAExC,qBAAqB;EACrB,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;;EAEhC,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;EAC1B,+BAA+B;EAC/B,6CAA6C;;EAE7C,4BAA4B;EAC5B,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,6BAA6B;EAC7B,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,sCAAsC;EACtC,2CAA2C;EAC3C,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,+BAA+B;EAC/B,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB;uCACqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uDAAuD;EACvD,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf;sCACoC;EACpC,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,uDAAuD;EACvD;wCACsC;AACxC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe,EAAE,2BAA2B;AAC9C;;AAEA;EACE,aAAa,EAAE,0CAA0C;AAC3D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;EAC5C,yBAAyB;EACzB,WAAW;AACb;;AAEA,kDAAkD;AAClD;;EAEE,8BAA8B;EAC9B,sDAAsD;EACtD,+CAA+C;AACjD;;AAEA;;EAEE,8BAA8B;EAC9B,sDAAsD;EACtD,kDAAkD;AACpD;;AAEA,gCAAgC;AAChC;;EAEE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;;EAEE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,mBAAmB;AACnB;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,8CAA8C;EAC9C,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,yBAAyB,EAAE,QAAQ;EACnC,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB,EAAE,UAAU;AACvC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB;;+BAE6B;EAC7B,UAAU;EACV,aAAa;EACb,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;EAClD,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA,sEAAsE;AACtE;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,oCAAoC;EACpC,oDAAoD;EACpD,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB,EAAE,2CAA2C;EACtE,cAAc,EAAE,4CAA4C;AAC9D;;AAEA;EACE,yBAAyB,EAAE,yCAAyC;EACpE,cAAc,EAAE,mCAAmC;AACrD;;AAEA;EACE,yBAAyB,EAAE,4CAA4C;EACvE,cAAc,EAAE,sCAAsC;AACxD;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;EACnD,cAAc,EAAE,uCAAuC;AACzD;;AAEA;EACE,yBAAyB,EAAE,UAAU;AACvC;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;EAClD,cAAc,EAAE,UAAU;AAC5B;;AAEA;EACE,yBAAyB,EAAE,SAAS;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,gDAAgD;EAChD,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8EAA8E;EAC9E,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,cAAc;AAChB;AACA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf;yCACuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD;0CACwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,8BAA8B;EAC9B,yCAAyC;EACzC,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,+BAA+B;EAC/B,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,aAAa;EACb,8EAA8E;AAChF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,6CAA6C;EAC7C,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,4DAA4D;AAC9D;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,4BAA4B;AAC5B;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;;;EAGE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,4CAA4C;AAC5C;EACE,wBAAwB;AAC1B","sourcesContent":[":root {\n  --vae-font-size-scale: 1;\n  --vae-line-height: 1.5;\n  --vae-letter-spacing: 0px;\n  --vae-word-spacing: 0px;\n  --vae-background-color: #ffffff;\n  --vae-text-color: #000000;\n  --vae-contrast-factor: 1;\n  --vae-text-contrast: 1;\n  --vae-animation-speed: 1;\n  --vae-interactive-highlight-color: #2563eb;\n  --vae-interactive-highlight-outline: 2px;\n  --vae-cursor-size: 24px;\n  --vae-cursor-color: #2563eb;\n  \n  /* Layout variables */\n  --vae-container-padding: 1rem;\n  --vae-content-padding: 1rem;\n  --vae-header-height: 72px;\n  \n  /* Icon sizing variables */\n  --vae-section-icon-size: 2.625rem;\n  --vae-section-icon-inner-size: 1.5rem;\n  --vae-section-icon-border-radius: 0.5rem;\n  \n  /* Header variables */\n  --vae-border-color: #E5E7EB;\n  --vae-header-icon-bg: #2563eb;\n  --vae-header-icon-color: #ffffff;\n  \n  /* Profile card variables */\n  --vae-modal-bg: #ffffff;\n  --vae-modal-text: #111827;\n  --vae-subtle-bg: #f9fafb;\n  --vae-footer-text: #6b7280;\n  --vae-profile-icon-size: 1.5rem;\n  --vae-profile-icon-container-padding: 0.25rem;\n\n  --vae-primary-color: #2563eb;\n  --vae-primary-rgb: 37, 99, 235;\n  --vae-bg-light: #ffffff;\n  --vae-bg-dark: #171717;\n  --vae-text-light: #171717;\n  --vae-text-dark: #f5f5f5;\n  --vae-subtle-bg: #f9f9f9;\n  --vae-subtle-bg-dark: #262626;\n  --vae-modal-bg: #ffffff;\n  --vae-modal-bg-dark: #262626;\n  --vae-border-light: #e5e5e5;\n  --vae-border-dark: #404040;\n  --vae-hover-light: #f5f5f5;\n  --vae-hover-dark: #333333;\n  --vae-shadow-color: rgba(0, 0, 0, 0.1);\n  --vae-shadow-color-dark: rgba(0, 0, 0, 0.3);\n  --vae-modal-text: #262626;\n  --vae-modal-text-dark: #e5e5e5;\n}\n\n.vae-severity-critical {\n  background-color: #dc2626 !important;\n  color: white !important;\n}\n\n.vae-severity-high {\n  background-color: #ea580c !important;\n  color: white !important;\n}\n\n.vae-severity-medium {\n  background-color: #eab308 !important;\n  color: black !important;\n}\n\n.vae-severity-low {\n  background-color: #22c55e !important;\n  color: white !important;\n}\n\n.vae-severity-unknown {\n  background-color: #6b7280 !important;\n  color: white !important;\n}\n\n.vae-severity-section.vae-severity-critical .vae-collapsable-header {\n  border-left: 4px solid #ef4444;\n}\n\n.vae-severity-section.vae-severity-high .vae-collapsable-header {\n  border-left: 4px solid #f97316;\n}\n\n.vae-severity-section.vae-severity-medium .vae-collapsable-header {\n  border-left: 4px solid #f59e0b;\n}\n\n.vae-severity-section.vae-severity-low .vae-collapsable-header {\n  border-left: 4px solid #10b981;\n}\n\n.vae-fix-detail-item .vae-detail-severity {\n  display: inline-block;\n  padding: 0.2rem 0.5rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  border-radius: 0.25rem;\n  margin-right: 0.5rem;\n}\n\n.vae-detail-severity.vae-severity-critical {\n  background-color: #fee2e2;\n  color: #b91c1c;\n}\n\n.vae-detail-severity.vae-severity-high {\n  background-color: #ffedd5;\n  color: #c2410c;\n}\n\n.vae-detail-severity.vae-severity-medium {\n  background-color: #fef3c7;\n  color: #b45309;\n}\n\n.vae-detail-severity.vae-severity-low {\n  background-color: #d1fae5;\n  color: #047857;\n}\n\n.vae-detail-severity {\n  text-transform: capitalize;\n  font-weight: 500;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: 12px;\n  color: white;\n}\n\n#vae-widget-container {\n  font-size: 16px !important;\n  line-height: 1.5 !important;\n  letter-spacing: normal !important;\n  word-spacing: normal !important;\n  position: fixed;\n  bottom: 2rem;\n  right: 4rem;\n  z-index: 2147483647;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,\n    'Helvetica Neue', Arial, sans-serif;\n}\n\n#vae-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(to right, #2563eb, #7c3aed);\n  border: none;\n  border-radius: 0.5rem;\n  padding: 0.75rem;\n  cursor: pointer;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),\n    0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  color: white;\n  width: 3.5rem;\n  height: 3.5rem;\n}\n\n#vae-button:hover {\n  background: linear-gradient(to right, #1d4ed8, #6d28d9);\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),\n    0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n\n#vae-button:focus {\n  outline: none;\n  ring: 2px;\n  ring-offset: 2px;\n  ring-color: #2563eb;\n}\n\n.vae-button-content {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.vae-logo-container {\n  width: 2rem;\n  height: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.vae-logo {\n  width: 2rem;\n  height: 2rem;\n  stroke: #3B82F6; /* Blue stroke - restored */\n}\n\n#vae-button .vae-logo {\n  stroke: white; /* White stroke only for the button logo */\n}\n\n.vae-button-text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.vae-button-title {\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  color: white;\n}\n\n.vae-button-title a {\n  color: white;\n  text-decoration: none;\n}\n\n.vae-status-led {\n  position: absolute;\n  top: -0.25rem;\n  right: -0.25rem;\n  width: 0.5rem;\n  height: 0.5rem;\n  background: #ef4444;\n  border-radius: 9999px;\n  box-shadow: 0 0 6px rgba(239, 68, 68, 0.8);\n  transition: all 0.3s ease;\n}\n\n.vae-status-led.active {\n  background: #34d399;\n  box-shadow: 0 0 6px rgba(52, 211, 153, 0.8);\n}\n\n/* Header Status LED */\n.vae-header-status-led {\n  position: absolute;\n  top: -0.375rem;\n  right: -0.375rem;\n  width: 0.75rem;\n  height: 0.75rem;\n  background: #6b7280;\n  border-radius: 9999px;\n  box-shadow: 0 0 6px rgba(107, 114, 128, 0.5);\n  transition: all 0.3s ease;\n  z-index: 10;\n}\n\n/* Analysis Status Colors - with higher priority */\n.vae-status-led.analysis-completed,\n.vae-header-status-led.analysis-completed {\n  background: #10b981 !important;\n  box-shadow: 0 0 8px rgba(16, 185, 129, 0.8) !important;\n  animation: vae-led-glow 2s ease-in-out infinite;\n}\n\n.vae-status-led.analysis-in-progress,\n.vae-header-status-led.analysis-in-progress {\n  background: #f97316 !important;\n  box-shadow: 0 0 6px rgba(249, 115, 22, 0.8) !important;\n  animation: vae-led-pulse 1.5s ease-in-out infinite;\n}\n\n/* Profile and Settings Status */\n.vae-status-led.active-profile,\n.vae-header-status-led.active-profile {\n  background: #8b5cf6;\n  box-shadow: 0 0 6px rgba(139, 92, 246, 0.8);\n}\n\n.vae-status-led.active-settings,\n.vae-header-status-led.active-settings {\n  background: #f59e0b;\n  box-shadow: 0 0 6px rgba(245, 158, 11, 0.8);\n}\n\n/* LED Animations */\n@keyframes vae-led-glow {\n  0%, 100% {\n    box-shadow: 0 0 8px rgba(16, 185, 129, 0.8);\n  }\n  50% {\n    box-shadow: 0 0 16px rgba(16, 185, 129, 1);\n  }\n}\n\n@keyframes vae-led-pulse {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.8;\n    transform: scale(0.95);\n  }\n}\n\n/* Version Display */\n.vae-version-number {\n  position: absolute;\n  bottom: 0.25rem;\n  right: 0.5rem;\n  font-size: 0.65rem;\n  color: #9ca3af;\n  font-family: 'Courier New', Courier, monospace;\n  opacity: 0.7;\n  z-index: 5;\n  user-select: none;\n  pointer-events: none;\n}\n\n.vae-footer .vae-version-number {\n  position: absolute;\n  bottom: 0.25rem;\n  right: 0.5rem;\n}\n\n.vae-status-dot {\n  width: 0.5rem;\n  height: 0.5rem;\n  border-radius: 9999px;\n  background-color: #EF4444; /* Red */\n  margin-left: 0.5rem;\n  display: inline-block;\n}\n\n.vae-status-dot.active {\n  background-color: #34D399; /* Green */\n}\n\n.vae-button-subtitle {\n  font-size: 0.625rem;\n  opacity: 0.9;\n  line-height: 1;\n  white-space: nowrap;\n  margin-top: 0.25rem;\n}\n\n.vae-mobile-tooltip {\n  position: absolute;\n  right: 0;\n  bottom: 100%;\n  margin-bottom: 0.5rem;\n  display: none;\n}\n\n.vae-mobile-tooltip-content {\n  background: #111827;\n  color: white;\n  font-size: 0.75rem;\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n  white-space: nowrap;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n#vae-button:hover .vae-mobile-tooltip-content {\n  opacity: 1;\n}\n\n#vae-menu {\n  position: absolute;\n  bottom: 4rem;\n  right: 0;\n  width: 28rem;\n  height: 80vh;\n  max-height: 80vh;\n  background: white;\n  border-radius: 0.5rem;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.15),\n    0 10px 10px -5px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(0, 0, 0, 0.05),\n    0 0 20px rgba(0, 0, 0, 0.1);\n  padding: 0;\n  display: none;\n  opacity: 0;\n  transform: translateY(1rem);\n  transition: opacity 0.3s ease, transform 0.3s ease;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n#vae-menu.open {\n  display: flex;\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.vae-content {\n  flex: 1;\n  overflow-y: auto;\n  margin-top: 0;\n}\n\n/* Make sure the content takes up all available space when displayed */\n.vae-content:only-child {\n  display: block;\n}\n\n.vae-content::-webkit-scrollbar {\n  width: 0.375rem;\n}\n\n.vae-content::-webkit-scrollbar-track {\n  background: #f3f4f6;\n  border-radius: 0.25rem;\n}\n\n.vae-content::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 0.25rem;\n}\n\n.vae-content::-webkit-scrollbar-thumb:hover {\n  background: #9ca3af;\n}\n\n.vae-section-divider {\n  margin: 1.5rem 0 0.75rem 0;\n  padding-top: 1rem;\n}\n\n.vae-content .vae-section-divider:first-child {\n  margin-top: 0;\n}\n\n.vae-section-divider h3 {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #4b5563;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.vae-section-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--vae-section-icon-size);\n  height: var(--vae-section-icon-size);\n  border-radius: var(--vae-section-icon-border-radius);\n  color: white;\n}\n\n.vae-section-icon svg {\n  width: var(--vae-section-icon-inner-size);\n  height: var(--vae-section-icon-inner-size);\n}\n\n/* Colored backgrounds for section icons */\n.vae-text-icon {\n  background-color: #f3e8ff; /* Light purple - matches Kognitive Hilfe */\n  color: #a855f7; /* Purple stroke - matches Kognitive Hilfe */\n}\n\n.vae-colors-icon {\n  background-color: #dcfce7; /* Light green - matches Sehbehinderung */\n  color: #22c55e; /* Green - matches Sehbehinderung */\n}\n\n.vae-motion-icon {\n  background-color: #fff7ed; /* Light orange - matches Motorische Hilfe */\n  color: #f97316; /* Orange - matches Motorische Hilfe */\n}\n\n.vae-language-icon {\n  background-color: #e5e0ff; /* Light purplish-blue */\n  color: #6366f1; /* Indigo/purple - matches Indigo-600 */\n}\n\n.vae-config-icon {\n  background-color: #10B981; /* green */\n}\n\n.vae-profile-icon {\n  background-color: #e0f2fe; /* Light neutral blue */\n  color: #000000; /* Black */\n}\n\n.vae-reader-icon {\n  background-color: #3B82F6; /* blue */\n}\n\n.vae-menu-header {\n  display: flex;\n  flex-direction: column;\n  padding: var(--vae-container-padding);\n  border-bottom: 1px solid var(--vae-border-color);\n  background-color: white;\n  box-sizing: border-box;\n  position: relative;\n  z-index: 11;\n}\n\n.vae-header {\n  flex-shrink: 0;\n  border-bottom: 1px solid var(--vae-border-color);\n}\n\n.vae-header-content {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n}\n\n.vae-text-icon-wrapper {\n  background-color: #EBF5FF;\n  border-radius: 0.5rem;\n  padding: 0.75rem;\n  width: 2.5rem;\n  height: 2.5rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.vae-text-icon-wrapper .vae-text-icon-letter {\n  font-size: 1.5rem;\n  font-weight: 500;\n  color: #4F46E5;\n}\n\n.vae-menu-title-section {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.vae-menu-subtitle {\n  font-size: 0.85rem;\n  color: #6B7280;\n  margin-bottom: 0.25rem;\n}\n\n.vae-menu-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #111827;\n  margin: 0 0 0.25rem 0;\n  line-height: 1.2;\n}\n\n.vae-menu-attribution {\n  font-size: 0.85rem;\n  color: #6B7280;\n}\n\n.vae-menu-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.vae-icon-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem;\n  color: #6b7280;\n  border: none;\n  background: none;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  gap: 0.25rem;\n}\n\n.vae-icon-button .vae-button-text {\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.vae-icon-button svg {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n.vae-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem 1rem;\n  background: #2563eb;\n  color: white;\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: all 200ms;\n}\n\n.vae-button:hover {\n  background: #1d4ed8;\n}\n\n.vae-section-title {\n  font-size: 1.3rem;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #1f2937;\n  width: 100%;\n}\n\n.vae-fixed-list,\n.vae-issues-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.vae-fixed-item {\n  border-left: 3px solid #34d399;\n}\n\n.vae-issue-item {\n  border-left: 3px solid #fbbf24;\n}\n\n.vae-fixed-label {\n  display: inline-block;\n  margin-left: 0.5rem;\n  font-weight: 500;\n  color: #059669;\n}\n\n.vae-all-fixed-message {\n  background-color: #d1fae5;\n  border-radius: 0.375rem;\n  padding: 1rem;\n  text-align: center;\n  margin-top: 1rem;\n}\n\n.vae-all-fixed-message p {\n  margin: 0;\n  color: #065f46;\n  font-weight: 500;\n}\n\n.vae-analysis-progress {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 0;\n}\n\n.vae-loading-spinner {\n  width: 2rem;\n  height: 2rem;\n  border: 3px solid #e5e7eb;\n  border-top-color: #2563eb;\n  border-radius: 50%;\n  margin-bottom: 1rem;\n  animation: vae-spin 1s linear infinite;\n}\n\n@keyframes vae-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.vae-issue-description {\n  font-size: 0.85rem;\n  color: #4b5563;\n  margin-bottom: 0.25rem;\n  margin-top: 5px;\n  line-height: 1.5;\n}\n\n.vae-fix-summary-container {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: #333;\n  background: white;\n  border-radius: 0.75rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n  width: 100%;\n}\n\n.vae-fix-summary-container h4 {\n  margin: 0 0 10px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n}\n\n.vae-fix-summary-container h5 {\n  margin: 15px 0 8px 0;\n  font-size: 16px;\n  font-weight: 500;\n  color: #555;\n}\n\n.vae-fix-summary-header h4 {\n  margin: 0 0 0.5rem 0;\n  font-size: 1.125rem;\n  color: #111827;\n}\n\n.vae-fix-overview {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 15px;\n  margin: 10px 0;\n}\n.vae-fix-button {\n  width: 100%;\n  display: block;\n  margin: 0 auto;\n  background: linear-gradient(90deg, #2563eb, #4f46e5);\n  color: white;\n  border: none;\n  border-radius: 0.5rem;\n  padding: 0.875rem 1.5rem;\n  font-weight: 600;\n  font-size: 0.95rem;\n  cursor: pointer;\n  box-shadow: 0 4px 6px -1px rgba(79, 70, 229, 0.2),\n    0 2px 4px -1px rgba(79, 70, 229, 0.1);\n  transition: all 0.2s ease;\n}\n\n.vae-fix-button:hover {\n  background: linear-gradient(90deg, #1d4ed8, #4338ca);\n  box-shadow: 0 6px 10px -1px rgba(79, 70, 229, 0.25),\n    0 4px 6px -1px rgba(79, 70, 229, 0.15);\n  transform: translateY(-1px);\n}\n\n.vae-fix-button:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.4);\n}\n\n.vae-fix-button:disabled {\n  background: linear-gradient(90deg, #93c5fd, #a5b4fc);\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n}\n.vae-fix-count {\n  font-size: 0.9rem;\n  font-weight: 500;\n  padding: 3px 8px;\n  border-radius: 4px;\n  background: #f5f5f5;\n}\n.vae-fix-total-count {\n  background: #e9e9e9;\n}\n.vae-fix-success-count {\n  color: #28a745;\n  background: rgba(40, 167, 69, 0.1);\n}\n.vae-fix-failure-count {\n  color: #dc3545;\n  background: rgba(220, 53, 69, 0.1);\n}\n\n.vae-fix-details-list {\n  list-style: none;\n  padding: 0.75rem;\n  margin: 0;\n  max-height: 300px;\n  overflow-y: auto;\n  font-size: 14px;\n}\n\n.vae-fix-detail-item {\n  padding: 0.75rem;\n  margin-bottom: 0.5rem;\n  background-color: white;\n  border-radius: 0.375rem;\n  border-left: 3px solid #e5e7eb;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.vae-fix-detail-item:last-child {\n  border-bottom: none;\n}\n\n.vae-fix-detail-item.vae-failure {\n  background-color: rgba(220, 53, 69, 0.05);\n}\n\n.vae-fix-detail-item.vae-success {\n  background-color: rgba(40, 167, 69, 0.05);\n}\n\n.vae-collapsable-header {\n  width: 100%;\n  text-align: left;\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  transition: background-color 0.2s;\n  padding: 0.75rem 1rem;\n  position: relative;\n  transition: all 0.2s ease;\n  border-top-left-radius: 0.5rem;\n  border-top-right-radius: 0.5rem;\n  border-bottom-left-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n}\n\n.vae-collapsable-header:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.vae-collapsable-section {\n  margin-bottom: 1rem;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  transition: box-shadow 0.2s ease;\n}\n\n.vae-collapsable-section:hover {\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n\n.vae-section-count {\n  font-weight: normal;\n  color: #eee;\n  margin-left: 6px;\n}\n\n.vae-collapsable-content {\n  background-color: #f9fafb;\n  border-bottom-left-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n}\n\n.vae-detail-action {\n  display: inline-block;\n  font-weight: 600;\n  font-size: 0.85rem;\n  color: #4b5563;\n  margin-right: 0.5rem;\n  max-width: 80%;\n}\n\n.vae-detail-wcag {\n  display: inline-block;\n  font-size: 0.75rem;\n  background-color: #e0f2fe;\n  color: #0c4a6e;\n  padding: 0.2rem 0.5rem;\n  border-radius: 0.25rem;\n  font-weight: 500;\n}\n\n.vae-detail-target {\n  font-family: monospace;\n  font-size: 0.85rem;\n  background-color: #f8fafc;\n  padding: 0.5rem;\n  border-radius: 0.25rem;\n  overflow-x: auto;\n  white-space: nowrap;\n  color: #334155;\n  border: 1px solid #e2e8f0;\n}\n\n.vae-detail-header {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n.vae-detail-status {\n  font-weight: bold;\n  text-align: center;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 50%;\n  margin-right: 0.5rem;\n}\n\n.vae-detail-status:first-child {\n  background-color: #d1fae5;\n  color: #047857;\n}\n\n.vae-detail-status:first-child:not(:only-child) {\n  background-color: #fee2e2;\n  color: #b91c1c;\n}\n\n.vae-detail-duration {\n  font-family: monospace;\n  font-size: 0.75rem;\n  background-color: #f3f4f6;\n  padding: 0.2rem 0.4rem;\n  border-radius: 0.25rem;\n  color: #6b7280;\n  margin-left: auto;\n}\n\n.vae-detail-error {\n  margin-top: 0.5rem;\n  padding: 0.5rem;\n  background-color: #fee2e2;\n  border-left: 3px solid #b91c1c;\n  color: #b91c1c;\n  border-radius: 0.25rem;\n  font-size: 0.875rem;\n}\n.vae-results-panel {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  width: 320px;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  padding: 15px;\n  z-index: 9999;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.vae-results-panel h3 {\n  margin: 0 0 10px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.vae-stats {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 15px;\n}\n\n.vae-stat {\n  text-align: center;\n  flex: 1;\n  padding: 8px;\n  border-radius: 4px;\n}\n\n.vae-stat-success {\n  background-color: rgba(76, 175, 80, 0.1);\n}\n\n.vae-stat-failed {\n  background-color: rgba(244, 67, 54, 0.1);\n}\n\n.vae-stat-skipped {\n  background-color: rgba(255, 152, 0, 0.1);\n}\n\n.vae-stat-value {\n  display: block;\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.vae-stat-label {\n  font-size: 12px;\n  color: #666;\n}\n\n.vae-fix-details {\n  margin-top: 10px;\n}\n\n.vae-fix-details summary {\n  cursor: pointer;\n  padding: 8px 0;\n  user-select: none;\n}\n\n.vae-fix-list {\n  max-height: 200px;\n  overflow-y: auto;\n  margin-top: 8px;\n}\n\n.vae-fix-item {\n  padding: 8px;\n  margin-bottom: 4px;\n  border-radius: 4px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.vae-fix-type {\n  flex: 1;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.vae-fix-status {\n  width: 20px;\n  text-align: center;\n  font-weight: bold;\n}\n\n.vae-fix-time {\n  font-size: 11px;\n  color: #666;\n  margin-left: 8px;\n}\n\n/* Maximize accessibility button */\n.vae-maximize-button {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  font-size: 0.9375rem;\n  font-weight: 500;\n  border-radius: 0.5rem;\n  background-color: #2563eb;\n  color: white;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.vae-maximize-button:hover {\n  background-color: #1d4ed8;\n}\n\n.vae-reading-mode-toggle {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.875rem 0;\n  border-bottom: 1px solid #E5E7EB;\n  margin-bottom: 0.75rem;\n}\n\n.vae-toggle-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 500;\n  font-size: 0.9rem;\n  color: #111827;\n}\n\n.vae-toggle-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #6B7280;\n}\n\n.vae-toggle-icon svg {\n  width: 1rem;\n  height: 1rem;\n}\n\n.vae-toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 2.5rem;\n  height: 1.5rem;\n}\n\n.vae-toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.vae-toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #E5E7EB;\n  transition: .3s;\n  border-radius: 1rem;\n}\n\n.vae-toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 1.25rem;\n  width: 1.25rem;\n  left: 0.125rem;\n  bottom: 0.125rem;\n  background-color: white;\n  transition: .3s;\n  border-radius: 50%;\n}\n\ninput:checked + .vae-toggle-slider {\n  background-color: #2563EB;\n}\n\ninput:checked + .vae-toggle-slider:before {\n  transform: translateX(1rem);\n}\n\n.vae-footer {\n  display: flex;\n  flex-direction: column;\n  padding: var(--vae-container-padding);\n  border-top: 1px solid var(--vae-border-color);\n  background-color: white;\n  font-size: 0.75rem;\n  gap: 16px;\n  position: relative;\n}\n\n.vae-footer-columns-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.vae-footer-links-column {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.vae-footer-privacy-row {\n  width: 100%;\n  text-align: center;\n  padding-top: 8px;\n  border-top: 1px solid var(--vae-border-color-light, #e5e7eb);\n}\n\n.vae-footer a {\n  color: #6b7280;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.vae-footer a:hover {\n  text-decoration: underline;\n}\n\n.vae-footer-link {\n  cursor: pointer;\n}\n\n/* Dark mode adjustments */\n.vae-high-contrast .vae-profile-card.active {\n  border-color: #fff;\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.vae-high-contrast-light .vae-profile-card.active {\n  border-color: #000;\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .vae-profile-card {\n    transition: none;\n  }\n}\n\n#vae-optimization-summary-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 10rem;\n}\n\n.vae-issue-description {\n  font-size: 0.85rem;\n  color: #4b5563;\n  margin-bottom: 0.25rem;\n  margin-top: 5px;\n  line-height: 1.5;\n}\n\n#vae-settings-view {\n  padding: var(--vae-content-padding);\n}\n\n/* Developer Tools Section */\n.vae-developer-tools {\n  padding: 1rem 0;\n}\n\n.vae-developer-tools .vae-button {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  border-radius: 0.5rem;\n  background-color: #6b7280;\n  color: white;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  margin-bottom: 0.5rem;\n}\n\n.vae-developer-tools .vae-button:hover:not(:disabled) {\n  background-color: #4b5563;\n}\n\n.vae-developer-tools .vae-button:disabled {\n  background-color: #9ca3af;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.vae-developer-tools .vae-help-text {\n  font-size: 0.75rem;\n  color: #6b7280;\n  margin: 0;\n  line-height: 1.4;\n}\n\n/* High contrast adjustments for developer tools */\n.vae-high-contrast .vae-developer-tools .vae-button {\n  background-color: #000000;\n  color: #ffffff;\n  border: 2px solid #ffffff;\n}\n\n.vae-high-contrast .vae-developer-tools .vae-button:hover:not(:disabled) {\n  background-color: #333333;\n}\n\n.vae-high-contrast-light .vae-developer-tools .vae-button {\n  background-color: #ffffff;\n  color: #000000;\n  border: 2px solid #000000;\n}\n\n.vae-high-contrast-light .vae-developer-tools .vae-button:hover:not(:disabled) {\n  background-color: #f3f4f6;\n}\n\n/* Hide language features */\n.vae-section-divider h3:has(.vae-language-icon),\n.vae-section-divider:has(.vae-language-icon),\n.vae-language-profiles {\n  display: none;\n}\n\n.vae-title-dropdown-wrapper,\n.vae-section-title-with-dropdown .vae-select-wrapper {\n  display: none;\n}\n\n/* Hide analysis start button */\n#vae-analysis-button-container {\n  display: none;\n}\n\n/* Hide footer elements */\n#vae-problem-report-link,\n#vae-optimization-report-link {\n  display: none;\n}\n\n.vae-footer-privacy-row {\n  display: none;\n}\n\n/* Footer single row layout */\n.vae-footer .vae-footer-single-row {\n  display: flex !important;\n  flex-direction: row !important;\n  gap: 1rem !important;\n  justify-content: flex-start !important;\n}\n\n.vae-footer .vae-footer-single-row a:last-child {\n  margin-left: auto !important;\n}\n\n/* Hide privacy consent overlay completely */\n#vae-privacy-consent-overlay {\n  display: none !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
